import React from "react";

/**
 * @name CCTM_link
 * @function
 * @extends React.Component
 * @exported true
 * @description This component dynamically renders a given component and provides link navigation functionality.
 * @param {Object} props - Component properties.
 * @param {React.Component} props.component - The component to be rendered.
 * @param {Function} [props.postRender] - Optional function to modify the component before rendering.
 * @param {string} props.to - The target hash URL for navigation.
 * @param {string} props.target - Specifies where to open the link ('window' to open in a new tab).
 * @example
 * export default function CCTM_link(props) {
 *  return (
 *    <CCTM_link component={MyComponent} to="/example" target="window" />
 *  );
 * }
 */

export default function CCTM_link(props) {
    
    // Extract the component from props
    let Component = props.component;
 
    // If a postRender function is provided, use it to modify the component before rendering
    if (typeof props.postRender == "function") {
        Component = props.postRender(props.component, props);
    } 
    
    // Set default onClick behavior
    let onClick = Component.onClick;
    
    // If the target is set to 'window', modify the onClick to open in a new tab
    if (props.target === "window") {
        onClick = () => {   
            if(props.to.indexOf("//") == -1 ) {                   
                window.open(window.location.origin + window.location.pathname + window.location.search + "#" + props.to, "_blank");   
            } else{
                window.open( props.to, "_blank");     
            }         
        };
    }
    
    // Render the component with modified onClick handler
    return <Component {...props} onClick={onClick} />;
}
